import { render, staticRenderFns } from "./vListContent.vue?vue&type=template&id=5f87611a"
import script from "./vListContent.vue?vue&type=script&lang=js"
export * from "./vListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../gim-wms/gim-wms-backend-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports